export default __webpack_public_path__ + "static/media/icon-twitter.ed53dc71.svg";